import React from "react";
import "../../assets/chatasset/assets/styles/chat.css";
import "../../assets/chatasset/assets/styles/style.css";

// Component
import Contactlist from "../../components/chat-components/Contact-list-component/Contact-list.component";
import { connect } from "react-redux";
import { setselectedusername } from "../../redux/actions/actions";

import ChatComponent from "../../components/chat-components/Chat-component/Chat.component";
import UserListComponent from "../../components/chat-components/User-list-component/User-list.component";

const mapStateToProps = (state) => {
  return {
    chat: state.data.chat,
    CustomerDetailsShow: state.data.CustomerDetailsShow,
    userlistshow: state.data.userlistshow,
    showExternalChat: state.data.showExternalChat,
  };
};

const Chat = (props) => {
  const { CustomerDetailsShow } = props;

  return (
    <>
      <section className="dashboard overflow-hidden">
        <div className="container-fluid">
          <div className="wapper_sub">
            <div className="sub_wapper">
              <div className="container-fluid p-0">
                <div className="row dvh-89">
                  <Contactlist />
                  <ChatComponent />
                  {(() => {
                    switch (props.userlistshow) {
                      case true:
                        return <UserListComponent />;
                      default:
                        return <></>;
                    }
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default connect(mapStateToProps, {
  setselectedusername,
})(Chat);
